<template>
	<div>
		<el-dialog v-if="type === 'offTime'" :visible.sync="overTimeReserveWindowStatus" title="非營業時段預約確認" top="0"
			append-to-body @close="closeBtn" :class="$style.offLineReserveClass">
			<div :class="$style['offLineReserveClass__uText']">
				<p>您所選取的時段為非營業時段</p>
				<p>若預約該時段開始託管</p>
				<p>該筆訂單則會加收託管費用</p>
			</div>
			<el-form ref="form" label-width="80px">
				<el-form-item label="加收費用">
					<el-input v-model="dollar"><span slot="suffix" style="padding-right: 10px">元</span></el-input>
				</el-form-item>
			</el-form>

			<div :class="$style['offLineReserveClass__btnGroup']">
				<el-button class="is-round" type="primary" @click="offTimeReserveResolveFunc('add')">是，確認加價NT $ {{ dollar
				}}</el-button>
				<el-button class="is-round" @click="offTimeReserveResolveFunc('none')">是，無需加價</el-button>
				<el-button class="is-round" @click="$emit('previousFun')">取消，回上一步</el-button>
			</div>
		</el-dialog>

		<el-dialog v-if="type === 'overTime'" :visible.sync="overTimeReserveWindowStatus" title="非營業時段結束服務確認" top="0"
			append-to-body @close="closeBtn" :class="$style.offLineReserveClass">
			<div :class="$style['offLineReserveClass__uText']">
				<p>此服務結束時間為非營業時段</p>
				<p>若欲在此時段結束服務</p>
				<p>此筆訂單則會加收費用</p>
			</div>
			<el-form ref="form" label-width="80px">
				<el-form-item label="加收費用">
					<el-input v-model="dollar"><span slot="suffix" style="padding-right: 10px">元</span></el-input>
				</el-form-item>
			</el-form>

			<div :class="$style['offLineReserveClass__btnGroup']">
				<el-button class="is-round" type="primary" @click="offTimeReserveResolveFunc('add')">是，確認加價NT $ {{ dollar
				}}</el-button>
				<el-button class="is-round" @click="offTimeReserveResolveFunc('none')">是，無需加價</el-button>
				<el-button class="is-round" @click="$emit('previousFun')">取消，回上一步</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>

export default {
	name: 'OffLineReserveWindow',
	props: {
		overTimeReserveWindowStatus: {
			type: Boolean,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			dollar: 1000,
			cloneOffLineReserveWindowStatus: false
		};
	},
	computed: {},
	watch: {
		offLineReserveWindowStatus(nvl) {
			this.cloneOffLineReserveWindowStatus = nvl
		}
	},
	created() { },
	mounted() { },
	methods: {
		/**
		 * @description 關閉此視窗
		 */
		offTimeReserveResolveFunc(type) {
			const titleObj = {
				'overTime': '服務超時加價',
				'offTime': '非營業時間加價',
			}
			const oriParam = {
				type: '+',
				price: this.dollar,
				qty: 1,
				title: titleObj[this.type],
				priceId: '',
				moreType: this.type
			}
			if (type === 'add') {
				this.$emit('closeOffLineWindow', oriParam)
			}
			if (type === 'none') {
				this.$emit('closeOffLineWindow', {})
			}

		},
		closeBtn() {
			this.$emit('previousFun')
		}
	},
};
</script>

<style lang="scss" module>
.offLineReserveClass {
	:global {
		.el-dialog__title {
			font-size: 20px;
		}
	}

	&__uText {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		p {
			font-size: 14px;
			margin-top: 0;
			margin-bottom: 26px;
		}
	}

	&__btnGroup {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;

		:global {
			.el-button {
				width: 100%;
				margin-bottom: 14px;
			}
		}
	}
}
</style>
